<template lang="pug"></template>

<script>
export default {
    name: 'BotaoPersonaSucursales',
    componentOptions: {
        title: 'PersonaSucursales',
        actions: [
            [
                {
                    name: 'PersonaSucursales',
                    showView: false,
                    action: 'abrirPersonas',
                    route: 'PersonaSucursales',
                    nameTranslationKey: 'mensagens.menuLateral.pessoa'
                }
            ]
        ]
    },

    methods: {
        abrirPersonas() {
            if (this.$route.name !== 'PersonaSucursales') {
                this.$router.push({
                    name: 'PersonaSucursales'
                });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
